import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { Input, FormActions, Select, DateTimeInput, Checkbox } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onSubmit, onReset, initialize, loading, individualConsultationTypes, paymentStatusTypes, paymentMethods, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='parent' component={Input} type='text' label={t('IndividualConsultation_Parent')} />
						</Col>
						<Col sm={6}>
							<Field name='child' component={Input} type='text' label={t('IndividualConsultation_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' filter={center => !center.isKindergarten} label={t('IndividualConsultation_Center')} />
						</Col>
						<Col sm={6}>
							<Select name='type' label={t('IndividualConsultation_Type')} data={individualConsultationTypes} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='status' label={t('PaymentHistory_Status')} data={paymentStatusTypes} />
						</Col>
						<Col sm={6}>
							<Select name='paymentMethodId' label={t('PaymentHistory_PaymentMethod')} data={paymentMethods} />
						</Col>
					</Row>
					<Row>
						<Col sm={3}>
							<Field name='paymentDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('PaymentHistory_PaymentDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
						<Col sm={3}>
							<Field name='consultationDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('IndividualConsultation_ConsultationDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='consultationDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='hasRefund' component={Checkbox} label={t('PaymentHistory_HasRefund')} normalize={(v) => { return !!v }} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, false))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, true))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'individualConsultationsFilter' })(withTranslation()(Filter));